import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';

// Static legend rendered under each chart so series are identified by label text,
// not colour alone.
const ChartLegend = (props) => {
  const {
    items,
  } = props;

  return (
    <Box
      component='ul'
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1.5,
        listStyle: 'none',
        m: 0,
        px: 0.5,
        py: 1,
      }}
    >
      {
        items.map((item) => (
          <Box
            key={item.key}
            component='li'
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.75,
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: item.color,
                flexShrink: 0,
              }}
            />
            <Typography sx={{fontSize: '12px', fontWeight: 500, color: '#6B6761'}}>
              {item.label}
            </Typography>
          </Box>
        ))
      }
    </Box>
  );
};

ChartLegend.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  })).isRequired,
};

export default React.memo(ChartLegend);
